// import project1_1 from "../assets/project-1.1.png";
// import project1_2 from "../assets/project-1.2.png";
// import project2_1 from "../assets/project-2.1.png";
// import project2_2 from "../assets/project-2.2.png";

import mbhr1 from "../assets/images/moon_bar/hory/PXL_20251120_122804700.NIGHT-EDIT.jpg";
import mbsq7 from "../assets/images/moon_bar/sqr/PXL_20251120_123845399-EDIT.jpg";
import mbsq9 from "../assets/images/moon_bar/sqr/PXL_20251120_124536884.jpg";
import mbsq10 from "../assets/images/moon_bar/sqr/PXL_20251120_124712432-EDIT.jpg";

import mbsq3 from "../assets/images/moon_bar/sqr/PXL_20251120_122545006.jpg";
import mbsq6 from "../assets/images/moon_bar/sqr/PXL_20251120_123748142.NIGHT-EDIT.jpg";
import mbvt1 from "../assets/images/moon_bar/vert/PXL_20251120_122735050.NIGHT-EDIT.jpg";
import mbvt2 from "../assets/images/moon_bar/vert/PXL_20251120_123638553.NIGHT-EDIT.jpg";

import mbhr2 from "../assets/images/moon_bar/hory/PXL_20251120_123052606.NIGHT-EDIT.jpg";
import mbhr3 from "../assets/images/moon_bar/hory/PXL_20251120_123316534-EDIT.jpg";
import mbsq1 from "../assets/images/moon_bar/moon-main.jpg";
import mbsq2 from "../assets/images/moon_bar/sqr/PXL_20251120_122337263.jpg";
import mbsq4 from "../assets/images/moon_bar/sqr/PXL_20251120_122906617.NIGHT.jpg";
import mbsq5 from "../assets/images/moon_bar/sqr/PXL_20251120_123121399.NIGHT.jpg";
import mbsq8 from "../assets/images/moon_bar/sqr/PXL_20251120_124015085-EDIT.jpg";
import mbsq11 from "../assets/images/moon_bar/sqr/PXL_20251120_125127940-EDIT.jpg";
import mbsq12 from "../assets/images/moon_bar/sqr/PXL_20251120_130458113.NIGHT.jpg";
import mbsq13 from "../assets/images/moon_bar/sqr/PXL_20251120_130658733.NIGHT.jpg";
import mbvt3 from "../assets/images/moon_bar/vert/PXL_20251120_125659969.NIGHT.jpg";

import bosq1 from "../assets/images/bothra_office/bothra-main.jpg";
import bosq2 from "../assets/images/bothra_office/hory/PXL_20251108_074207423-EDIT.jpg";
import bosq3 from "../assets/images/bothra_office/hory/PXL_20251108_075551986-EDIT.jpg";
import bosq4 from "../assets/images/bothra_office/hory/PXL_20251108_075200654-EDIT.jpg";
import bosq5 from "../assets/images/bothra_office/hory/PXL_20251108_075522578-EDIT.jpg";

import aosq1 from "../assets/images/apollo_office/apollo-main.jpg";
import aosq2 from "../assets/images/apollo_office/hory/PXL_20251108_092944258.jpg";
import aosq3 from "../assets/images/apollo_office/hory/PXL_20251108_093015878.jpg";
import aosq4 from "../assets/images/apollo_office/hory/PXL_20251108_093104363.jpg";
import aosq5 from "../assets/images/apollo_office/hory/PXL_20251108_094002808.jpg";
import aosq6 from "../assets/images/apollo_office/hory/PXL_20251108_094024538-EDIT.jpg";
import aosq7 from "../assets/images/apollo_office/hory/PXL_20251108_094149597.jpg";
import aosq8 from "../assets/images/apollo_office/hory/PXL_20251108_094301843-EDIT.jpg";
import aosq9 from "../assets/images/apollo_office/hory/PXL_20251108_094318324.jpg";

const project1_2 = [mbhr1, mbsq7, mbsq9, mbsq10, ];
const project1_3 = [mbsq3, mbsq6, mbvt1, mbvt2];

const project1 = [mbsq1, mbsq2, mbsq3, mbsq4];
const project2 = [bosq1, bosq2, bosq3, bosq4, bosq5];
const project3 = [aosq1, aosq2, aosq3, aosq4, aosq5, aosq6, aosq7, aosq8, aosq9];

const moonbar = {
    title: "Moon Bar & Kitchen",
    location: "VIP Road, Visakhapatnam",
    scope: "Specialized Restoration & Renovation",
    objective: "Revitalizing the Atmosphere",
    // objective: "",
    execution: "This project demonstrates our capability in high-end maintenance and restoration. It highlights our attention to detail in handling specialized materials and our ability to execute a complete refresh of a hospitality space with speed and precision.",
    mandate: "For Moon Bar & Kitchen, ARC Studioz was tasked with a sensitive refurbishment mandate: to breathe new life into the venue’s signature elements without altering its iconic identity. The challenge was not to build anew, but to restore and refine the existing intricate features, requiring a deep understanding of materials ranging from epoxy resins to vintage joinery.",
    helightTitle: "Restoration Highlights",
    highlights: [
        {
            head: "Upholstery & Soft Furnishing Upgrade",
            content: "We breathed new life into the existing furniture inventory through a comprehensive re-upholstery program. By selecting premium, durable fabrics that complement the dark, moody atmosphere, we transformed worn seating into plush, inviting elements that elevate the tactile experience for every guest.",
            imagesSet: []
        },
        {
            head: "Bespoke Furniture",
            content: "To enhance seating comfort and style, we manufactured custom-made sofas. Specifically for this space. Designed to withstand high-traffic hospitality use, these pieces were crafted to align perfectly with the venue's industrial-chic vibe, ensuring a cohesive look between the new additions and the existing furniture.",
            imagesSet: project1_2
        },
        {
            head: "Epoxy Table Restoration",
            content: "The venue features complex resin 'river' tables that had seen significant wear. Our team executed a meticulous repair and polishing process, removing surface abrasions and restoring the optical clarity of the epoxy. We brought the finish back to a high-gloss, glass-like sheen, reviving the depth of the blue resin and the warmth of the embedded wood.",
            imagesSet: project1_3
        },
        {
            head: "Door Refurbishment & Duco Finishing",
            content: "The vintage doors are a key aesthetic feature. We repaired the underlying joinery to ensure structural soundness and applied a fresh, premium Duco paint finish. This process involved careful surface preparation to retain the character of the doors while delivering a flawless, durable color coat that aligns with the venue's vibrant theme.",
            imagesSet: []
        },
        {
            head: "Preserving the Architectural Shell",
            content: "The site is defined by its existing complex brickwork, 'floating' wooden block ceiling, and dramatic lighting systems. Our role was to carefully clean, touch up, and maintain these features, ensuring the acoustic and visual integrity of the ceiling and the dramatic 'pin-spot' lighting effect remained undisturbed during the renovation process.",
            imagesSet: []
        },
        {
            head: "Neon & Art Integration",
            content: "We worked to ensure the retro-futuristic neon artworks and murals were seamlessly integrated into the refreshed surroundings, balancing the vibrancy of the art against the newly restored dark, moody finishes of the interior.",
            imagesSet: []
        }

    ]
}

const bothra = {
    title: "Bothra Shipping Corporate Office",
    location: "SAMPATH VINAYAK TEMPLE ROAD, VISAKHAPATNAM",
    scope: "Civil Execution & Turnkey Interiors",
    objective: "",
    execution: "The Bothra Shipping Head Office stands as a benchmark of our execution capabilities. It demonstrates our ability to manage large-scale corporate projects, from civil facade work to intricate interior finishes to deliver a seamless, move-in-ready headquarters.",
    mandate: "For the headquarters of Bothra Shipping, we served as the principal execution partner, charged with the responsibility of translating a sophisticated architectural vision into a tangible reality. This project required a comprehensive contracting approach, covering everything from the structural exterior facade to the finest interior details. Our role was to ensure that the high-performance design was delivered with absolute structural integrity and finishing precision.",
    helightTitle: "Execution Highlights",
    highlights: [
        {
            head: "Building Elevation & Façade Engineering",
            content: "We executed the building’s striking exterior elevation, a defining feature of the building. This involved the precise installation of the vertical louver systems and staggered structural elements that provide both solar shading and a modern aesthetic. Additionally, we fabricated and installed the external emergency staircase.",
            imagesSet: project2
        },
        {
            head: "Executive Cabins & Workstations",
            content: "The interior execution focused on creating a hierarchy of privacy and collaboration. We managed the fit-out of open-plan workstations designed for productivity, alongside premium executive cabins enclosed in high-grade glass partitioning. Our team ensured seamless integration of electrical and data grid systems within the furniture and flooring to maintain a clutter-free environment.",
            imagesSet: []
        },
        {
            head: "Conference Rooms & Collaborative Spaces",
            content: "We delivered high-tech conference rooms and breakout lounges, focusing heavily on acoustic comfort and premium material application. From the installation of wooden flooring to the mounting of AV systems, every detail was managed to facilitate seamless communication.",
            imagesSet: []
        },
        {
            head: "Luxury Washrooms with Stretch Ceilings",
            content: "A standout feature of the facility is the executive washrooms. We executed complex wet-area detailing, including the installation of large-format stone cladding and premium sanitary ware. The highlight is the illuminated stretch ceiling system, which creates a diffuse, skylight-like effect, adding a touch of modern luxury to the amenities.",
            imagesSet: []
        },
        {
            head: "Dining & Recreational Zones",
            content: "Understanding the importance of employee well-being, we executed the dining areas and recreational zones with durable, high-traffic finishes. These spaces were fitted with custom joinery and robust lighting solutions to create a relaxed yet professional atmosphere.",
            imagesSet: []
        },
        // {
        //     head: "",
        //     content: "",
        //     imagesSet: []
        // }
    ]
}

const apollo = {
    title: "Apollo Shipping Office",
    location: "Suryabagh, Visakhapatnam",
    scope: "Turnkey Interior Fit-out & Comprehensive MEP/IT Execution",
    objective: "",
    execution: "The Apollo Shipping project stands as a testament to our 'Plug-and-Play' contracting capabilities. By managing every aspect of the build—from the hidden fire safety pipes to the visible stretch ceilings—we delivered a workspace that was ready for business from day one.",
    mandate: "For the Apollo Shipping office, ARC Studioz served as the execution partner, tasked with transforming a bare shell into a fully operational corporate office. This project was an exercise in technical integration, where high-end aesthetic finishes had to coexist seamlessly with a heavy-duty infrastructure backbone. Our role was to execute the architect's vision with absolute fidelity while ensuring the functional systems behind the walls were robust and future-proof.",
    helightTitle: "Interior Execution Highlights",
    highlights: [
        {
            head: "Operational & Executive Zones",
            content: "We managed the complete fit-out of the open-plan workstations and private Manager Cabins. This involved the precise installation of glass partitioning systems to maintain visual connectivity while ensuring acoustic privacy. The layout was executed to maximize workflow efficiency without compromising on the spatial quality.",
            imagesSet: []
        },
        {
            head: "The Conference Room & Stretch Ceiling",
            content: "The centerpiece of the office is the main conference room, where we installed a premium illuminated stretch ceiling. This specialized installation provides uniform, shadow-less lighting essential for video conferencing and presentations, adding a sleek, modern aesthetic to the meeting space.",
            imagesSet: []
        },
        {
            head: "Reception & Amenities",
            content: "We executed the Reception and Waiting Lounge, featuring custom joinery and integrated branding elements. Additionally, we executed the Cafeteria and Washrooms with high-durability finishes and premium sanitary fixtures to ensure comfort and longevity.",
            imagesSet: []
        },
        {
            head: "The Hidden Architecture: MEP & IT Infrastructure",
            content: "What makes this project a benchmark for ARC Studioz is the scope of the 'invisible' work we executed:",
            imagesSet: []
        },
        {
            head: "Structured Cabling & IT",
            content: "We installed the entire data backbone, including high-speed Ethernet cabling and a comprehensive electrical grid to support heavy operational loads.",
            imagesSet: []
        },
        {
            head: "Security & Safety",
            content: " A fully integrated CCTV network was mapped and installed for total premise security, alongside a rigorous Fire Safety System that meets all statutory compliance standards.",
            imagesSet: []
        },
        {
            head: "Climate & Plumbing",
            content: "We executed the complete HVAC (Air Conditioning) and plumbing system, ensuring optimal climate control and water management throughout the facility.",
            imagesSet: []
        }

    ]
}

export const PROJECTS_MAP = {
    moonbar,
    bothra,
    apollo,
};

export const arcStudiozAddress = "58-1-235/116, E Block 302, Tarakarama Enclave, shanthi Nagar, NAD junction, Visakhapatnam, Andhra Pradesh - 530037, India."